import React, { Component } from 'react';
import { withStyles, Paper, Typography, TextField, Button, Divider, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Menu, MenuItem, Switch, FormGroup,
    Card, CardMedia, CardActions, CardContent, Slide } from '@material-ui/core';
import { Attachment } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import  Select, { Creatable } from 'react-select';
import creds from '../config/firebaseConfig';
import db from '../config/firestoreConfig';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

const styles = theme => ({
    root: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
      margin: 'auto',
      width: '50%',
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: 20,
      },
      textField: {
        paddingTop: 20,
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '80%',
       
      },
      QuestionField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: '100%',
      },
      WeightField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginTop: 20,
        width: '20%',
      },
      menu: {
        width: 200,
      },
      button: {
        margin: theme.spacing.unit,
      },
      input: {
        display: 'none',
      },
      formControl: {
        margin: theme.spacing.unit * 3,
      },
      group: {
        margin: `${theme.spacing.unit}px 0`,
      },
      select : {
          marginTop: 20, 
          width: '100%'
      },
      cardMedia: {
        // height: 140,
        },
    media: {
        maxHeight: '100%',
        maxWidth: '100%',
        height: 'auto',
        display: 'inline-block',

        // paddingTop: '56.25%', // 16:9
    },
});

const defaultQ = {
    id: 0,
    title: 'example',
    questionText: 'example',
    answers: 'example', 
    correctAns: 'example',
    imageURL: 'example'
};





class EditHwk extends Component {
    constructor(props) { 
        super(props)
        this.state = {
            checkedA: false,
            checkedB: false, 
            questions: [ ],
            newQuestion: {},
            newQuestionWeight: 0,
            newQuestionText: '',
            newQuestionTitle: '',
            value: '',
            answers: [],
            newAnswer: '',
            newTag: '',
            tags: [], 
            dbTagList: [],
            dbObjects: [],
            open: true,
            level: '', 
            subject: '',
            levels: [], 
            subjects: [],
            years: [],
            year: '',
            abilities: ['Beginner', 'Intermediate', 'Advanced'],
            ability: '', 
            sections: [],
            section: '',
            relevantSections: [],
            selectedFile: [],
            fileForQ: { name: null},
            totalMarks: 0,
            tagMenuOptions: [],
            newTagArr: [],
            newTagsForDB: [],
            ansError: false,
            overwrite: false,
            imgOpen: false,
            activeImg: '',
            src: '',        
        }
    }

    componentDidMount = () => {
        if (sessionStorage.getItem('AccountType')  != 'Teacher' && sessionStorage.getItem('AccountType')  != 'Admin'){
            creds.fb.auth().signOut()
            .then( 
              sessionStorage.clear(),
              window.location.replace('/'),
              window.alert('You have been signed out'))
            .catch((error) => { 
                console.log(error)
            })
        }
        db.collection('AssignedTasks').doc(this.props.match.params.title).get()
        .then((doc) => { 
            if (doc.exists){
                return this.setState({
                    OGname: doc.title,
                    alreadySetWarning: true
                })
            }
        })
        var title = this.props.match.params.title
        var id
        var arr
        var tags = this.state.dbTagList
        var searchedSubjects = []  
        const levelRef = db.collection('Level')
        levelRef.get()
            .then(snapshot => {
                snapshot.forEach( level => {
                    var subj = []
                    console.log(level.id)
                    this.state.levels.push(level.id)
                    // console.log(this.state.levels)
                    const subjRef = levelRef.doc(level.id).collection('Subjects')
                    subjRef.get()
                    .then(snapshot => {
                        snapshot.forEach(subject => {
                            
                            // console.log('sibject id', subject.id)
                            var years = []
                            subj.push(subject.id)
                            const yearRef = subjRef.doc(subject.id).collection('Years')
                            yearRef.get()
                            .then(snapshot => { 
                                snapshot.forEach(year => { 
                                    var abilities = []
                                    years.push(year.id)
                                    const abilityRef = yearRef.doc(year.id).collection('Abilities')
                                    abilityRef.get()
                                    .then(snapshot=> { 
                                        snapshot.forEach(ability => { 
                                            var dbObject = {level: level.id, subject: subject.id, year: year.id, ability: ability.id, content: ability.data().data.Content.Sections}
                                            this.state.dbObjects.push(dbObject)
                                            // console.log('ability obj', ability.id, ability.data().data.Content.Sections)
                                            // console.log('current object', dbObject)
                                            var content = []
                                            abilities.push([level.id, subject.id, year.id, ability.id])
                                            var obj = [level.id, subject.id, year.id, ability.id, ability.data().data.Content.Sections ]
                                            // console.log('section', obj)
                                            // console.log(this.state.sections) //Debug
                                            //HAVE WE SEARCHED FOR THIS SUBJECTS TAGS ALREADY
                                            if (searchedSubjects.indexOf(subject.id) == -1){
                                                searchedSubjects.push(subject.id)
                                                db.collection('Tags').doc(subject.id).get()
                                                .then( snapshot => { 
                                                    var tagArr = (snapshot.data())
                                                    tags.push(tagArr)
                                                    this.setState({
                                                        dbTagsList: tags,
                                                    })
                                                })
                                            }
                                        })
                                    })
                                })
                            })   
                        }) 
                    }) 
                    this.state.subjects.push(subj)
                    // console.log('state subjects', subj)
                })
            })
            this.loadTest(title)
            console.log(this.state)
        // db.collection('Level').doc(this.state.level).collection('Subjects').doc(this.state.subject)
    }


    loadTest = (title) => { 
        var testRef = db.collection('Tests').doc(title)
        var testData
        var questions
        var test 
        var imgArr = []
        var tags = [] 
        var files =[]
        var totalMarks = 0
        testRef.get()
        .then(snapshot => { 
            testData = snapshot.data().data
            test = testData.isTest
            questions = testData.questions
            console.log(testData)
            questions.forEach( async question => {
                if (question.file != null) {
                    var storageRef = creds.fb.storage();
                    var imgRef =  storageRef.ref('/images/' + title + '/' + question.file)
                    const url = await imgRef.getDownloadURL()
                    var file
                    console.log(url)
                    console.log(imgArr)
                    imgArr.push({url: url, question: questions.indexOf(question)})
                    var img = document.getElementById(question.id)
                    fetch(img.src)
                    .then( res => res.blob())
                    .then( async blob => {
                        file = await new File([blob], question.file, {type: 'image/jpeg'}, blob)
                        console.log('FILE FROM LOAD TEST', file)
                        files.push(file)
                        // this.fileSelectedHandler2(file)
                    })
                    console.log('IMG', file, question.id, img.id)
                    img.src = url
                }
                question.answers.forEach( async answer => { 
                    if (answer.file != false  && answer.file != null){
                        console.log('FETCHING', answer)
                        var storageRef = creds.fb.storage();
                        var imgRef =  storageRef.ref('/images/' + title + '/' + answer.value)
                        const url = await imgRef.getDownloadURL()
                        console.log(url)
                        console.log(imgArr)
                        imgArr.push({file:answer.file, url: url, question: testData.questions.indexOf(question)})
                        var img = document.getElementById(answer.file)
                        fetch(img.src)
                        .then( res => res.blob())
                        .then( async blob => {
                            var file = await new File([blob], answer.file, {type: 'image/jpeg'}, blob)
                            console.log('FILE FROM LOAD TEST', blob, files)
                            files.push(file)
                            // this.fileSelectedHandler2(file)
                        })
                        console.log('IMG', img, answer.id,)
                        if (img) {
                            img.src = url
                            this.setState({...this.state})
                        }
                    }
                })
            })
            console.log(totalMarks, tags, imgArr)
            console.log('SELECTED FILE', files)
            this.setState({
                ...this.state,
                title: title,
                checkedA: test,
                questions: questions,
                images: imgArr, 
                tags: tags,
                OGname: '',
                totalMarks: testData.totalMarks,
                selectedFile: files,
            })
        })

        
    }


    buildSelectMenu = (subject) => {
        const Tags = this.state.dbTagList
        console.log('build Menu started: ' + JSON.stringify(Tags)) //Debug
        var relevantTags = []
        var menuOptions = [] 
        // console.log(subject)
        if (subject.length > 0){
            Tags.forEach(list => {
                if (list && list.Name == subject) {
                    // console.log('line 146 :' + JSON.stringify(list)) //Debug
                    return relevantTags = relevantTags.concat(list.Tags)
                }
            })
        } else {
            Tags.forEach(list => {
                relevantTags = relevantTags.concat(list.Tags)
            })
        }
        // console.log('line 155 : ' + JSON.stringify(relevantTags)) //Debug
        relevantTags.forEach(tagComp => {
            menuOptions.push({label: tagComp.Tag, value: tagComp.Tag})
        })
        this.setState({
            newTagsForDB: relevantTags,
            tagMenuOptions: menuOptions
        })
        this.chooseObjects('subject', this.state.subject,'year')
    }

    questionSheet = () => { 
        return (
            this.state.questions.map(question => { 
                <TextField
                    id='questionText' 
                    className={ styles.textField } 
                    value={question.questionText}
                >
                {question.questionText}
                </TextField>
            })
        )
    }
    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClickOpenOverwriteWarning = () => {
        this.setState({ openOverwriteWarning: true });
    };

    handleIsTest = name => event => {
        this.setState({
            [name]: event.target.checked
        });
    };
    
    handleClose = () => {
        this.setState({ open: false });
    };

    handleClose3 = () => {
        if (!this.state.test.isTest) {
            this.setState({ 
                open: false,
                imgOpen: false,
                score: 0,

            });
        }
    };

    handleClose2 = () => {
        this.setState({ 
            open: false,
            imgOpen: false,
            score: 0,
            activeImg: '',
    
        });
        };


    handleCloseOverwriteWarning = () => {
        this.setState({ 
            openOverwriteWarning: false,
            overwrite: true,
            alreadySetWarning: false
        });
        this.finishSheet(this.state.questions, this.state.level, this.state.subject, this.state.year, this.state.ability, this.state.section, this.state.title, this.state.totalMarks)
    };

    checkNameChanged = () => { 
        const OGname = this.props.match.params.title
        var currentTitle = this.state.title
        if (OGname == currentTitle){
            return this.setState({
                ...this.state,
                sheetTitleError: true,
                OGname: this.props.match.params.title
            })
        } else {
            return this.setState({
                ...this.state,
                alreadySetWarning: false
            })
        }
    }

    handleChange = name => event => {
       
        console.log('NAME', name, 'VALUE', event.target.value, event, event.target  )
        if (name === 'level') {
        this.setState({
          [name]: event.target.value,
        }, function(){
            setTimeout( true , 3000)
        });
        } else if (name === 'subject') {
            this.setState({
                [name]: event.target.value,
                years: []
            });
            this.buildSelectMenu(event.target.value)
        } else if (name === 'year'){
            this.setState({
                [name]: event.target.value,
            });
        } else {
            this.setState({
                [name]: event.target.value,
                titleError : false,
                weightError: false, 
                ansError: false, 
                questionError: false,
                sheetTitleError : false,
                sheetLevelError: false, 
                sheetSubjectError: false, 
                sheetSectionError: false,
                year: this.state.year
            });
        }
            // console.log(this.state)
    };


    handleMarkChange = name => event => {
        // console.log(event.target.value)
        if (name === 'level') {
        this.setState({
          [name]: parseInt(event.target.value),
        }, function(){
            setTimeout( true , 3000)
        });
        } else {
            this.setState({
                [name]: parseInt(event.target.value),
            });
        }
            // console.log(this.state)
    };

    handleClose2 = () => {
        this.setState({ 
            open: false,
            imgOpen: false,
            activeImg: '',
            ansImg: '',
            ansOpen: false,
        });
    };


    handleNewTag = () => { 
        const updatedTags = this.state.tags.concat(this.state.newTag)
        console.log('updated tags: ' + updatedTags)
        this.setState({
            ...this.state,
            newTag: '',
            tags: updatedTags
        });
    }

    addQ = () => {
        var obj
        console.log('ADD Q', this.state.tags, )
        if (this.state.newQuestionText == '') { 
            return this.setState({titleError: false, questionError: true, ansError: false, weightError: false})
        }
        if (this.state.value == '') { 
            return this.setState({titleError: false, questionError: false, ansError: true, weightError: false})
        }
        if (this.state.newQuestionWeight <= 0) { 
            return this.setState({titleError: false, questionError: false, ansError: false, weightError: true})
        }
            if (this.state.fileForQ != null) { 
                obj = {
                    id: (this.state.questions.length + 1),
                    title: this.state.newQuestionTitle,
                    questionText: this.state.newQuestionText,
                    answers: this.state.answers,
                    tags: this.state.tags,
                    file: this.state.fileForQ.name,
                    weight: this.state.newQuestionWeight,
                    correctAns: this.state.value
                }
            } else {
                obj = {
                    id: (this.state.questions.length + 1),
                    title: this.state.newQuestionTitle,
                    questionText: this.state.newQuestionText,
                    answers: this.state.answers,
                    tags: this.state.tags,
                    file: null,
                    weight: this.state.newQuestionWeight,
                    correctAns: this.state.value
                }
            }
            var objWeight = parseInt(obj.weight)
            
            
            console.log('486', objWeight, this.state.totalMarks, parseInt(obj.weight), (this.state.totalMarks + parseInt(obj.weight)) )
            var newArr =  this.state.questions.concat([obj])
            this.setState({
                questions: newArr,
                newQuestionTitle: '', 
                newQuestionText: '',
                newQuestionWeight: '0',
                answers: [],
                tags: [],
                fileForQ: { name: null},
                value: '',
                newTagArr: [],
                totalMarks: this.state.totalMarks + objWeight,
                titleError : false,
                weightError: false, 
                ansError: false, 
                questionError: false
            })

            if (this.state.title == undefined || this.state.title == '' || this.state.title.includes('-')) { 
                this.handleClickOpen()
                return this.setState({sheetTitleError: true, sheetLevelError: false, sheetSubjectError: false, sheetSectionError: false})
            } else
            if (this.state.level == '') { 
                this.handleClickOpen()
                return this.setState({sheetTitleError: false, sheetLevelError: true, sheetSubjectError: false, sheetSectionError: false})
            } else 
            if (this.state.subject == '') { 
                this.handleClickOpen()
                return this.setState({sheetTitleError: false, sheetLevelError: false, sheetSubjectError: true, sheetSectionError: false})
            } else 
            if (this.state.section == '') { 
                this.handleClickOpen()
                return this.setState({sheetTitleError: false, sheetLevelError: false, sheetSubjectError: false, sheetSectionError: true})
            } else {
               return this.finishSheet(newArr, this.state.level, this.state.subject, this.state.year, this.state.ability, this.state.section, this.state.title, this.state.totalMarks + parseInt(obj.weight))
            }
            
         
        // console.log(parseInt(obj.weight))
        // console.log(this.state.totalMarks)
        // console.log(this.state.totalMarks + parseInt(obj.weight))
    }

    addAns = () => {
        if(this.state.newAnswer) {
            const obj = {
            id: (this.state.answers.length + 1),
            value: this.state.newAnswer
            }
            console.log(obj)
            var newArr =  this.state.answers.concat(obj)
            this.setState({
                answers: newArr,
                newAnswer: ''
            })
            console.log(this.state.questions)
        }
    }

    addAnsFile = file => {
        console.log('STATE', this.state, file)
        var obj = {
            id: (this.state.answers.length + 1),
            value: file.name,
            file: file.name
        } 
        console.log('IMAGE ANSWER', obj)
             
        console.log(obj)
        var newArr =  this.state.answers.concat(obj)
        this.setState({
            answers: newArr,
            newAnswer: '',
            fileForAns: false
        })
        console.log(this.state)
    }

    finishSheet = (sheetQuestions, level, subject, year, ability, section, title, maxScore) => {
        if (sheetQuestions.length < 1) {
            return this.handleClose()
        }
        if (title == undefined || title == '' || title.includes('-') || title == this.state.OGname) { 
            return this.setState({sheetTitleError: true, sheetLevelError: false, sheetSubjectError: false, sheetSectionError: false})
        }
        if (level == '') { 
            return this.setState({sheetTitleError: false, sheetLevelError: true, sheetSubjectError: false, sheetSectionError: false})
        }
        if (subject == '') { 
            return this.setState({sheetTitleError: false, sheetLevelError: false, sheetSubjectError: true, sheetSectionError: false})
        }
        if (section == '') { 
            return this.setState({sheetTitleError: false, sheetLevelError: false, sheetSubjectError: false, sheetSectionError: true})
        }
        if (this.state.checkedA && !this.state.timer || this.state.checkedA && this.state.timer == '00:00' || this.state.checkedA && !this.state.timer.length > 0 ) {
            return this.setState({sheetTitleError: false, sheetLevelError: false, sheetSubjectError: false, sheetSectionError: false, sheetTimerError: true})
        }
        console.log(maxScore)
        this.fileUploadHandler(this.state.selectedFile)
        console.log(this.state.checkedA)
        const checked = this.state.checkedA
        var data = {}
        if (checked){
            data = { 
                questions: sheetQuestions,
                totalMarks: maxScore,
                timer: this.state.timer,
                isTest: true,
                complete: this.state.checkedB
            }
        } else { 
            data = { 
                questions: sheetQuestions,
                totalMarks: maxScore,
                timer: 'N/A',
                isTest: false,
                complete: this.state.checkedB
            }
        }
        console.log('DATA', data)
        db.collection('Tests').doc(title).set({data}, {merge: true})
        .then( () =>  {
            console.log('subject: ' + subject)
            const testRef = db.collection('Level').doc(level).collection('Subjects').doc(subject).collection('Years').doc(year).collection('Abilities').doc(ability)
            if (this.state.checkedA && this.state.checkedB) { 
                testRef.get()
                    .then(doc => {
                        console.log(doc.data())
                        var content = doc.data().data.Content
                        console.log(content.Sections.find(sect => sect.Name === section))
                        const index  = content.Sections.findIndex(sect => sect.Name === section)
                        if (!content.Sections[index].Tests.includes(title)) { 
                            content.Sections[index].Tests.push(title)
                        }
                        // window.alert(content)
                       testRef.set({ data: {'Content' : content}}, {merge: true})
                       window.alert('Task saved successfully.')
                        this.setState({open: false})
                    })
                } else if (this.state.checkedB) {
                    testRef.get()
                    .then(doc => {
                        console.log(doc.data())
                        var HwK = doc.data().data.Content
                        console.log(HwK.Sections.find(sect => sect.Name === section))
                        const index  = HwK.Sections.findIndex(sect => sect.Name === section)
                        if (!HwK.Sections[index].HWK.includes(title)) {
                             HwK.Sections[index].HWK.push(title)
                             testRef.set({ data: {'Content' : HwK}}, {merge: true})
                        } else {
                            if (!this.state.overwrite){
                                return this.handleClickOpenOverwriteWarning()
                            } else {
                                HwK.Sections[index].HWK.push(title)
                                testRef.set({ data: {'Content' : HwK}}, {merge: true})
                                window.alert('Task saved successfully.')
                                this.setState({open: false})
                            }                 
                        }
                       
                    })
                } else {
                    window.alert('Task saved successfully.')
                }
            
        })
        
    }

    deleteQuestion = (id)  => { 
        var updatedQuestionList = this.state.questions.filter(function(question){
            return question.id != id
        })
        this.setState({
            questions: updatedQuestionList
        })
    }

    makeList = () => { 
        const index = this.state.levels.indexOf(this.state.level)
        const arr = this.state.subjects
        if (index != -1) { 
            this.state.subjects[index].map(subject => {
                return ( 
                        <MenuItem key={this.state.subjects.indexOf(subject)} value={subject}> 
                            {subject}
                        </MenuItem>
                )
            })
        }
        
    }

    fileSelectedHandler = event => {
        var arr = this.state.selectedFile
        if (event.target && event.target.files[0]){
            // console.log('HEREEEE', event.target.files[0], event.target.files[0].type)
            if (event.target.files[0].type.includes('image')){
                arr.push(event.target.files[0])
                this.setState({
                selectedFile: arr,
                fileForQ: event.target.files[0]
                })
                window.alert('File added to upload queue')
            } else {
                console.error('You tried to upload a file that wasnt an image file: ' + event.target.files[0].name)
                return window.alert('You tried to upload a file that wasnt an image file: "' + event.target.files[0].name + '", ' + event.target.files[0].type + ' files are not accepted. Please try again with an image file (.png, .jpg or .jpeg).')
            }
        } else {
            console.error('No file was selected.')
        }
    }

    fileSelectedHandler2 = event => {
        var arr = this.state.selectedFile
        if (event && event.target && event.target.files[0]) {
            // console.log('HEREEEE', event.target.files[0], event.target.files[0].type)
            if (event.target.files[0].type.includes('image')){
                //Do the right thing
                arr.push(event.target.files[0]) 
                this.setState({
                    selectedFile: arr,
                    fileForAns: event.target.files[0],
                    newAnswer: event.target.files[0].name
                })
                window.alert('File added to upload queue')
                this.addAnsFile(event.target.files[0])
            } else {
                //throw the error
                console.error('You tried to upload a file that wasnt an image file: ' + event.target.files[0].name)
                return window.alert('You tried to upload a file that wasnt an image file: "' + event.target.files[0].name + '", ' + event.target.files[0].type + ' files are not accepted. Please try again with an image file (.png, .jpg or .jpeg).')
            }
        } else {
            console.error('No file was selected.')
        }
    }

    fileUploadHandler = (arr) => {
        var storage = creds.fb.storage()
        var storageRef = storage.ref()
        var successCount = 0
        var imagesRef = storageRef.child('images')
        arr.forEach(file => {
            try { 
                var testRef = imagesRef.child(this.state.title + '/' + file.name)
                var uploadTask = testRef.put(file)
                uploadTask.on('state_changed', function(snapshot){
                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done')
                }, function(error){
                    console.error(error)
                }, function () {
                    uploadTask.snapshot.ref.getDownloadURL().then(function(url){
                        successCount = successCount + 1
                        console.log('file available at: ' + url)
                    })
                })
            } catch (err) {
                return window.alert('There was an error: ' +  err)
            }

            if (successCount == arr.length){ 
                console.log('ALL FILES UPLOADED')
                window.alert('Files successfully uploaded.')
            }
        })
    }

    editQuestion = (question) => { 
        console.log('start of edit Q ')
        console.log(question)
        console.log(this.state)
        console.log(parseInt(question.weight))
        console.log(this.state.totalMarks)
        const arr = this.state.questions
        var index = 0
        var qIndex
        arr.forEach(Q => { 
            if (Q.id == question.id) {
                return qIndex = index
            }
        })
        console.log(qIndex)
        arr.splice(qIndex, 1);
        arr.forEach(Q => { 
            if (Q.id > qIndex){
                Q.id = Q.id-1
            }
        })
        console.log(arr)
        this.setState({
            questions: arr,
            newQuestionText: question.questionText,
            newQuestionTitle: question.title,
            newQuestionWeight: question.weight,
            tags: question.tags,
            totalMarks: (this.state.totalMarks) - parseInt(question.weight)
        })
        console.log((this.state.totalMarks) - parseInt(question.weight))
        console.log(this.state)
    }

    fetchTopics = () => {
        console.log(this.state.sections)
    }

    logChange(val){
        console.log('Selected : ' + val)
    }

    

    tagSelected = (tag, meta) => {
        console.log(tag, meta)
        var existingTags = this.state.newTagArr
        var allTags = this.state.tagMenuOptions
        var arr = this.state.newTagsForDB
        var questionTags = this.state.tags
        switch (meta.action) {
            case 'select-option':
                console.log('you selected', tag)
                console.log(existingTags)
                console.log(tag[tag.length -1].value)
                questionTags.push(tag[tag.length -1].value)
                existingTags = tag
                this.setState({newTagArr: existingTags, tags: questionTags})
                break;
            
            case 'create-option':
                console.log('you created', tag[tag.length - 1])
                console.log(existingTags)
                console.log(tag[tag.length -1].value)
                questionTags.push(tag[tag.length -1].value)
                // console.log(existingTags)
                existingTags.push(tag[tag.length - 1])
                allTags.push(tag[tag.length - 1])
                arr.push({Tag: tag[tag.length - 1].value, Count: 0, Marks: 0})
                console.log(allTags)
                this.setState({newTagArr: existingTags, tags: questionTags, tagMenuOptions: allTags, newTagsForDB: arr})
                db.collection('Tags').doc(this.state.subject).set({
                    Tags: arr
                }, {merge: true})
                break;
            
            case 'remove-value':
                console.log('you removed', meta.removedValue.value)
                questionTags.splice(questionTags.indexOf(meta.removedValue.value), 1)
                this.setState({newTagArr: tag, tags: questionTags})
                break;
        }
    }

    chooseObjects =  (param, target, out) => { 
        console.log('start of choose object ')
        var outputArr = []
        var completeList = this.state.dbObjects
        completeList.map(obj => { 
            if (obj[param] == target && outputArr.indexOf(obj[out]) == -1){
                console.log(obj)
                this.state.years.push(obj[out]) 

            }
        })
    }

    outputSections = (obj) => { 
        console.log(obj)
        var output = [] 
        if (obj.length > 0 ){
            obj.map(section => {
                output.push( 
                    <MenuItem ley={1} value={section.Name}>
                        {section.Name}
                    </MenuItem>
                )
            })
        }
        return output
    }

    viewAns = (open, name) => {
        // console.log('NAME', name)
        this.setState({
            ansImg: name, 
            ansOpen: open,
        })
    }

    removeAnswer = (index) => { 
        
        var output = this.state.answers
        output.splice(index, 1)
        console.log(index, output, this.state.answers)
        this.setState({
            answers: output
        })
    }

    viewImg = (open, name) => {
        console.log('ACTIVE', name)
        this.setState({
            activeImg: name, 
            imgOpen: open,
        })
    }

    getAnswerImg = (file) => { 
        var images = this.state.images;
        var output;
        images.forEach( img => { 
            if (img.file == file){
                output = img.url
            }
        })
        return output
    }

    openImgInNewTab = (img) => {
        console.log(img.src)
        window.open(img.src, null, false)
    }
    
    displayImg = (img) => {
        console.log('HERE', img, this.state.activeImg)
        return <div style={{margin: 'auto', alignContent: 'center', alignItems: 'center', justifyContent: 'center', justifyItems: 'center'}}><img height='100%' width='100%'  src={img.src} /></div>
    }


    
    render () { 
        const { classes } = this.props;
        return (
            <div>
                <Paper className={classes.root} elevation={1}>
                    <Typography variant='headline' component='h3'> 
                         {this.state.title} Sheet
                    </Typography>
                        <Divider/>
                        <div className={classes.container}>
                        <br/>
                        <div>
                        
                    {this.state.questions.map(question => { 
                        return (
                            <div>
                                <Paper className={classes.container} elevation={1}>
                                        <Typography variant='title' component='h2' style={{display: 'block'}}>
                                            { (this.state.questions.indexOf(question) + 1) + ' - ' + question.title }
                                        </Typography>
                                    <br/>
                                    <br/>
                                    <TextField
                                        id='question'
                                        className={classes.QuestionField}
                                        multiline={true}
                                        value={question.questionText}
                                        defaultValue={question.questionText}
                                        
                                    />      
                                    <br/>
                                    {question.tags.map(tag => { 
                                       return (
                                           <div style={{width: '100%'}}>
                                                <Typography variant='caption' className={classes.QuestionField}>
                                                    {question.tags.indexOf(tag) == 0 ?
                                                        'Areas : ' + tag
                                                    :
                                                        tag
                                                    }
                                                </Typography>
                                            </div>
                                        )
                                    })}
                                    <br/>
                                    <br/>
                                    <div style={{maxHeight: 104, maxWidth: 140, marginBottom: 'auto', paddingTop: 10, paddingBottom: 20}}>
                                        {question.file != null ? 
                                            // <Button onClick={console.log('FILE', question.file)}>
                                            <div>
                                                <Button onClick={() => this.viewImg(!this.state.imgOpen, question.id)}>
                                                    <img id={question.id} alt={question.file} className={classes.media} src={this.state[question.file]}/>
                                                </Button>
                                                <Button variant='raised' onClick={() => this.viewImg(!this.state.imgOpen, question.id)}>
                                                    Detailed View
                                                </Button>
                                                <br/>
                                                <br/>
                                            </div>
                                            :
                                            <Typography variant='caption' style={{margin: 'auto'}}>
                                                {'No image was provided for this Quesiton'}
                                            </Typography>
                                        }
                                    </div>
                                    <br/>
                                    <br/>
                                    <div style={{width: '100%', paddingTop: 50}}>
                                        <FormControl component="fieldset" required className={classes.formControl}>
                                        <RadioGroup
                                            aria-label='Answers'
                                            value={question.correctAns}
                                        >
                                        <br/>
                                        <br/>
                                            {question.answers.map(answer => {
                                                        // console.log('STATE IMAGES', this.state.images, this.getAnswerImg(answer.file))
                                                        if (answer.file){
                                                                return (
                                                                        <FormControlLabel value={answer.value} control={<Radio/>} label={<Button onClick={() => this.viewAns(!this.state.ansOpen, answer.file)}><img id={answer.file} src={this.getAnswerImg(answer.file)} alt={answer.value} style={{ height: 150, width: 150}}/></Button>}disabled={!(answer.value == question.correctAns)}>
                                                                            
                                                                        </FormControlLabel>
                                                                )
                                                        } else {
                                                            return (
                                                                <FormControlLabel value={answer.value} control={<Radio/>} label={answer.value} disabled={!(answer.value == question.correctAns)}/>
                                                            )
                                                        }
                                                    })
                                            }
                                        </RadioGroup>
                                        <Typography className={classes.QuestionField}>
                                            {question.weight + ' Marks'}
                                        </Typography>  
                                        </FormControl>
                                    </div>       
                                    <br/>
                                    <Button className={classes.button} variant='raised' onClick={()=> this.deleteQuestion(question.id)}>
                                        Delete
                                    </Button>
                                    <Button className={classes.button} variant='raised' onClick={()=> this.editQuestion(question)}>
                                        Edit
                                    </Button>
                                </Paper>
                            <br/>
                            </div>
                            )
                    })}
                    <br/>
                    <Divider/>
                    </div>
                                                        {/*INPUT FORM FOR CREATING QUESTIONS*/}     
                    <TextField
                        id='input'
                        label='Question Title'
                        className={classes.QuestionField}
                        value={this.state.newQuestionTitle}
                        onChange={this.handleChange('newQuestionTitle', this.value)} 
                        error={this.state.titleError}
                    />
                    <br/>
                    <TextField
                        id='textarea'
                        label='Question Content'
                        multiline={true}
                        roswMax='4' 
                        className={ classes.QuestionField } 
                        value={this.state.newQuestionText}
                        onChange={this.handleChange('newQuestionText', this.value )} 
                        error={this.state.questionError}
                    />
                    
                    <br/>
                        <Creatable
                            name='tag-dropdown'
                            className={classes.select}
                            isMulti
                            placeholder='Tags for Question'
                            joinValues={true}
                            value={this.state.newTagArr}
                            options={this.state.tagMenuOptions}
                            onChange={(opt, meta) => this.tagSelected(opt, meta)}
                        />
                    <br/>
                    {!this.state.fileForAns ? 
                        <TextField
                            id='answers'
                            label='Answers'
                            multiline
                            roswMax='4' 
                            className={ classes.QuestionField } 
                            value={this.state.newAnswer}
                            onChange={this.handleChange('newAnswer', this.value)}
                        />
                    :
                        <div/>
                    }
                    
                     <input 
                        type='file'
                        style={{display: 'none'}}
                        onChange={this.fileSelectedHandler2}
                        ref={fileInput2 => this.fileInput2 = fileInput2}
                    />
                    <div style={{width: '100%'}}>
                   <Button onClick={() => this.fileInput2.click()}>
                        <Attachment/>
                    </Button>
                    </div>
                    <br/>
                    <div>
                        {this.state.fileForQ ?
                            <div>
                            <Typography variant='body2'>
                                File Attached to this question as an image: <strong>{this.state.fileForQ.name}</strong>
                            </Typography>
                            </div>
                        :
                            <div/>
                        }
                    </div>
                    </div>
                    <FormControl component="fieldset" required className={classes.formControl}>
                    {this.state.answers.length > 0 ? (
                        <div>
                        <FormLabel component="legend" error={this.state.ansError}>Select the correct answer</FormLabel>
                        <RadioGroup
                            aria-label="Answers"
                            name="gender1"
                            className={classes.group}
                            value={this.state.value}
                            onChange={this.handleChange('value', this.value)}
                            
                        >
                        {this.state.answers.map(answer => {
                            return (

                                    <FormControlLabel value={answer.value} control={<Radio/>} label={<span>{answer.value}<div><IconButton className={classes.button} onClick={()=> {this.removeAnswer(this.state.answers.indexOf(answer))}} aria-label="Delete">
                                        <DeleteIcon/>
                                    </IconButton></div></span>}/>
                            )
                        })}
                        </RadioGroup>
                        </div>
                    ) : (
                        <div/>
                    )}
                    <br/>
                     <TextField
                        id='marks'
                        label='Marks'
                        type='number'
                        className={classes.WeightField}
                        value={this.state.newQuestionWeight}
                        onChange={this.handleChange('newQuestionWeight', this.value,function(changeBack){
                            this.setState({weightError: false})
                        })} 
                        error={this.state.weightError}
                    />
                    
                    </FormControl>
                    <div style={{display: 'block',  bottom: 0, marginLeft: 'auto', marginRight: 'auto'}}>
                    <Button className={classes.button} variant='outlined' onClick={() => this.addAns()}>
                        Add Answer
                    </Button>
                    <input 
                        type='file'
                        style={{display: 'none'}}
                        onChange={this.fileSelectedHandler}
                        ref={fileInput => this.fileInput = fileInput}
                    />
                    <Button className={classes.button} variant='outlined' onClick={() => this.fileInput.click()}>
                        Attach Image 
                    </Button>
                    <Button variant='outlined' color='primary' className={classes.button} onClick={() => this.addQ()}>
                        Save Question
                    </Button>
                    {this.state.checkedA ? 
                        <Button variant='outlined' color='secondary' className={classes.button}  onClick={() => this.handleClickOpen()}>
                            Finish Test
                        </Button>
                    :
                        <Button variant='outlined' color='secondary' className={classes.button}  onClick={() => this.handleClickOpen()}>
                            Finish Homework
                        </Button>
                    }
                    <br/>
                    
                    </div>
                </Paper>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                    >
                    <DialogTitle id="form-dialog-title">Task Details</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            To finish creating this sheet and save it, please enter a title for this task.
                        </DialogContentText>
                        <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Task Title"
                        type="text"
                        helperText='Only numbers and letters.'
                        value={this.state.title}
                        onChange={this.handleChange('title', this.value)}
                        error={this.state.sheetTitleError}
                        fullWidth
                        />
                        <Divider/>
                        <br/>
                        <DialogContentText>
                            Which course is this task for?
                        </DialogContentText>
                        <TextField
                                id='Level'
                                select
                                label='Please select the suitable academic level'
                                className={classes.textField}
                                value={this.state.level}
                                onChange={this.handleChange('level')}
                                margin='normal'
                                helperText='Please select one'
                                error={this.state.sheetLevelError}
                            >
                                    {this.state.levels.map(level => {
                                        return (
                                            <MenuItem key={this.state.levels.indexOf(level)} value={level}> 
                                                {level}
                                            </MenuItem>
                                        )
                                        
                                    })}
                            </TextField> 
                        <br/>
                        <TextField
                                id='Subject'
                                select
                                label='Please select the suitable subject'
                                className={classes.textField}
                                value={this.state.subject}
                                onChange={this.handleChange('subject')}
                                margin='normal'
                                helperText='Please select one'
                                error={this.state.sheetSubjectError}
                            >
                                    {(this.state.levels.indexOf(this.state.level) != -1) ? 
                                        this.state.subjects[this.state.levels.indexOf(this.state.level)].map(obj => { 
                                            return  ( 
                                                <MenuItem key={1} value={obj}>
                                                    {obj}
                                                </MenuItem>
                                            )
                                        })
                                        
                                         
                                        
                                    : 
                                        <div/>
                                    
                                    }
                            </TextField>  
                            <br/>
                            <TextField
                                id='Year'
                                select
                                label='Please select the suitable year'
                                className={classes.textField}
                                value={this.state.year}
                                onChange={this.handleChange('year')}
                                margin='normal'
                                helperText='Please select one'
                                error={this.state.sheetYearError}
                            >
                                    {(this.state.levels.indexOf(this.state.level) != -1) && this.state.subject ? (
                                        this.state.dbObjects.map(obj => { 
                                            //only want to create an item for the object if the year and subject are correct (ability == advanced to stop duplcates)
                                            if (obj.level == this.state.level && obj.subject == this.state.subject && obj.ability == 'Advanced'){                                         
                                                return (
                                                    <MenuItem key={1} value={obj.year}>
                                                        {obj.year}
                                                    </MenuItem>
                                                )
                                            }
                                        })
                                    ) : (
                                        <div/>
                                    )
                                    }
                            </TextField>  
                            <br/>
                            <TextField
                                id='Subject'
                                select
                                label='Please select the suitable ability'
                                className={classes.textField}
                                value={this.state.ability}
                                onChange={this.handleChange('ability')}
                                margin='normal'
                                helperText='Please select one'
                                error={this.state.sheetSubjectError}
                            >
                                    {(this.state.levels.indexOf(this.state.level) != -1) ? (
                                        this.state.abilities.map( ability => {
                                            return (
                                                <MenuItem key={this.state.abilities.indexOf(ability)} value={ability}> 
                                                    {ability}
                                                </MenuItem>
                                            )
                                        })
                                    ) : (
                                        <div/>
                                    )
                                    }
                            </TextField>  
                            <br/>
                            <TextField
                                id='Section'
                                select
                                label='Please select the suitable seciton'
                                className={classes.textField}
                                value={this.state.section}
                                onChange={this.handleChange('section')}
                                margin='normal'
                                helperText='Please select one'
                                error={this.state.sheetSectionError}
                            >
                                    {(this.state.subjects.length >= 1) ? (
                                        this.state.dbObjects.map(obj => { 
                                            if (obj.level == this.state.level && obj.year == this.state.year && obj.subject == this.state.subject && obj.ability == this.state.ability) {
                                                return this.outputSections(obj.content)
                                            } 
                                        })
                                    ): (
                                        <div/>
                                    )
                                    }
                            </TextField>  
                            <br/>
                            <br/>
                            {this.state.checkedA == true ? 
                                <TextField
                                    id='time'
                                    label='Timer HH:MM'
                                    type='time'
                                    value={this.state.timer}
                                    onChange={this.handleChange('timer')}
                                    defaultValue='00:00'
                                    className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    inputProps={{
                                        step: 300, //5 min intervals
                                    }}
                                    error={this.state.sheetSectionError}

                                >
                                </TextField>
                            :
                                <div/>
                            }
                            <FormGroup row>
                                <FormControlLabel
                                control={
                                    <Switch
                                        checked={this.state.checkedA}
                                        onChange={this.handleIsTest('checkedA')}
                                        value="checkedA"
                                    />
                                }
                                label='Is a section test'
                                />
                            </FormGroup>
                            <FormGroup row>
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={this.state.checkedB}
                                            onChange={this.handleIsTest('checkedB')}
                                            value="checkedB"
                                        />
                                    }
                                    label='Task creation is complete'
                                />
                            </FormGroup>

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">
                            Add Questions
                        </Button>
                        <Button onClick={() => this.finishSheet(this.state.questions, this.state.level, this.state.subject, this.state.year, this.state.ability, this.state.section, this.state.title, this.state.totalMarks)} color="primary">
                            Finish
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.openOverwriteWarning}
                    onClose={this.handleCloseOverwriteWarning}
                    aria-labelledby="form-dialog-title"
                    >
                    <DialogTitle id="form-dialog-title">Warning</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Task '{this.state.title}' already exists, please either rename this task or re-enter and click continue to overwirte.
                        </DialogContentText>
                        <br/>
                        <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Task Title"
                        type="text"
                        helperText='Only numbers and letters.'
                        value={this.state.title}
                        onChange={this.handleChange('title', this.value)}
                        error={this.state.sheetTitleError}
                        fullWidth
                        />
                        <br/>
                        <Button
                            className={classes.button}
                            variant='outlined'
                            onClick={() => this.handleCloseOverwriteWarning()}
                        >
                            Save
                        </Button>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={this.state.alreadySetWarning}
                    onClose={this.checkNameChanged}
                    aria-labelledby="form-dialog-title"
                    >
                    <DialogTitle id="form-dialog-title">Warning</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Task '{this.state.title}' has already been created and set to students. Please Change the name of this task. 
                        </DialogContentText>
                        <br/>
                        <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Task Title"
                        type="text"
                        helperText='Only numbers and letters.'
                        value={this.state.title}
                        onChange={this.handleChange('title', this.value)}
                        error={this.state.sheetTitleError}
                        fullWidth
                        />
                        <br/>
                        <Button
                            className={classes.button}
                            variant='outlined'
                            onClick={() => this.checkNameChanged()}
                        >
                            Save
                        </Button>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={this.state.imgOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleClose2}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    >
                    <DialogContent>
                        <Card
                            className={classes.card}
                        >
                            <CardMedia>
                                <div className={classes.cardMedia}>
                                    {this.state.activeImg ? this.displayImg(document.getElementById(this.state.activeImg)) : console.log('No Active image yet')}
                                </div>
                            </CardMedia>
                            <CardContent>
                                {/* <Typography gutterBottom variant="display1" component="h2">
                                    {this.state.activeImg}
                                </Typography> */}
                                <div  component="p">
                                    {this.state.questions.map(question => {
                                       if (question.id == this.state.activeImg) {
                                        //    console.log('MATCHHHH', question.id, this.state.activeImg, question)
                                            return (
                                                <div>
                                                <Typography variant='headline'>
                                                    {question.questionText}
                                                </Typography>
                                                <hr/>
                                                
                                                    <Typography variant='button'>
                                                        Answers:
                                                    </Typography>
                                                    <FormControl component="fieldset" required className={classes.formControl}>
                                                        <span>
                                                        {question.answers.map(answer => {
                                                                    // console.log('STATE IMAGES', this.state.images, this.getAnswerImg(answer.file))
                                                                    if (answer.file){
                                                                        return (
                                                                            <Button onClick={() => this.openImgInNewTab(document.getElementById(answer.file))}>
                                                                                <img id={answer.file} src={this.getAnswerImg(answer.file)} alt={answer.value} style={{ height: 200, width: 200, margin: 10}}/>
                                                                            </Button>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <div style={{ margin: 5,  }}>
                                                                                <Button  variant='outlined' style={{width: 200}}>
                                                                                    {answer.value}
                                                                                </Button>
                                                                            </div>
                                                                        )
                                                                    }
                                                            })}
                                                            </span>
                                                            <hr/>
                                                    </FormControl>
                                                    {question.tags.length > 0 ? 
                                                        <Typography variant='caption'>
                                                            Areas: {question.tags.map(tag => { 
                                                                return tag + ', '
                                                            })}
                                                            
                                                        </Typography>
                                                    :
                                                        <div/>
                                                    }
                                                    <br/>
                                                    <Typography variant='subheading'>
                                                        {question.weight + ' Marks'}
                                                    </Typography>
                                                </div>
                                            )
                                       }
                                    })}
                                </div>
                            </CardContent>
                            <CardActions>
                                <Button size="small" color="primary" onClick={() => this.openImgInNewTab(document.getElementById(this.state.activeImg))}>
                                    View Fullscreen
                                </Button>
                            </CardActions>
                        </Card>
                        
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={this.state.ansOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handleClose2}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                    >
                    <DialogContent>
                        <Card
                            className={classes.card}
                        >
                            <CardMedia>
                                <div className={classes.cardMedia}>
                                    {this.state.ansImg ? this.displayImg(document.getElementById(this.state.ansImg)) : console.log('No Active image yet', this.state.ansImg)}
                                </div>
                            </CardMedia>
                            <CardContent>
                                {/* <Typography gutterBottom variant="headline" component="h2">
                                    {this.state.ansImg}
                                </Typography> */}
                                {/* <Typography variant='subheading' component="p">
                                    {this.state.test.questions.map(question => {
                                        var text = ''
                                       if (question.id == this.state.activeImg) {
                                           console.log(question.questionText)
                                           return text = question.questionText
                                       }
                                       return text

                                    })}
                                </Typography> */}
                            </CardContent>
                            <CardActions>
                                {/* <Button size="small" color="primary" onClick={() => this.openImgInNewTab(<div style={{margin: 'auto', alignContent: 'center', alignItems: 'center', justifyContent: 'center', justifyItems: 'center'}}><img height='100%' width='100%'  src={this.getAnswerImg(this.state.ansImage)} /></div> )}> */}
                                <Button size="small" color="primary" onClick={() => this.openImgInNewTab(document.getElementById(this.state.ansImg))}>
                                    View Fullscreen
                                </Button>
                            </CardActions>
                        </Card>
                        
                    </DialogContent>
                </Dialog>
            </div>
        )
    }
}

EditHwk.propTypes = {
    classes: PropTypes.object.isRequired,
  };


export default withStyles(styles)(EditHwk);



// WEBPACK FOOTER //
// ./src/admin/edit.jsx